//external
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
//internal
import { list } from 'services/traceabilityProductionReport/service';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { useDebounce } from 'utils/uiUtils';
import GridContainer from 'components/v2/grid';
import InputText from 'components/v2/inputText';
import TableAction from 'components/v2/tableAction';
import { sanitizeErrorUI } from 'utils/errorUtil';
import DataTableReact from 'components/v2/dataTableReact';
//style
import { IconContainer } from './styled';
import DataTableLoading from 'components/DataTableLoading';
import { FilterTraceability } from '..';
import DatePickers from 'components/v2/datePicker';

export default function Productions() {
  const message = useSelector(state => state.message.data);

  const [productions, setProductions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [initialDate, setInitialDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return d;
  });
  const [finalDate, setFinalDate] = useState(new Date());

  //Pagination
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState();
  const [reload] = useState(0);

  const { filter, setFilter } = useContext(FilterTraceability);

  const debouncedSearchTerm = useDebounce(searchTerm);
  const debvouncedInitialDate = useDebounce(initialDate);
  const debvouncedFinalDate = useDebounce(finalDate);

  const dispatch = useDispatch();

  const columns = [
    {
      name: 'Filial',
      selector: 'productProtheusBranch',
      sortable: false,
      maxWidth: "5%",
    },
    {
      name: 'Lote',
      selector: 'productionLot',
      sortable: false,
      maxWidth: "18%",
    },
    {
      name: 'Data de produção',
      sortable: false,
      selector: row => row.productionDate
        ? new Date(row.productionDate).toLocaleDateString('pt-BR')
        : '',
      maxWidth: "12%",
    },
    {
      name: 'Produto',
      selector: 'productProtheusCode',
      sortable: true,
      maxWidth: "10%",
    },
    {
      name: 'Descrição',
      selector: 'productProtheusDescription',
      sortable: true,
      maxWidth: "40%",
    },
    {
      name: 'Quantidade',
      selector: 'orderQty',
      style: { justifyContent: "flex-end" },
      sortable: true,
      maxWidth: "5%",
    },
    {
      maxWidth: '10%',
      style: { justifyContent: "flex-end" },
      cell: row =>
        <div>
          <IconContainer>
            <TableAction
              title={"Editar"}
              to={`/traceability/traceability_production_reports/${row.productionLot}`}>
              <VisibilityIcon />
            </TableAction>
          </IconContainer>
        </div>,
      sortable: true
    }
  ];

  useEffect(() => {
    setLoading(true);
    dispatch(startRequest());
    list(debouncedSearchTerm, perPage, filter.page, sort, debvouncedInitialDate, debvouncedFinalDate).then(data => {
      setTotalRows(parseInt(data.headers['recordcount']));
      setProductions(data.data);
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
      setLoading(false);
    });
  }, [debouncedSearchTerm, dispatch, filter.page, perPage, sort, reload, debvouncedInitialDate, debvouncedFinalDate]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  }

  const handlePageChange = (page) => {
    setFilter({ ...filter, page });
  };

  const handlePerRowsChange = (perPage) => {
    setPerPage(perPage);
  };

  const handleSort = (column, sortDirection) => {
    setSort(`${column.selector} ${sortDirection}`);
  };

  return (
    <>
      <ContentPanel message={message} title="Ordens de producao">
        <form>
          <GridContainer>
            <InputText
              xs={6}
              name="search"
              label="Pesquisar"
              type="text"
              placeholder="Pesquisar"
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
              hasWarning={false}
            />
            <DatePickers
              xs={3}
              name="initialDate"
              label="Início"
              value={initialDate}
              onChange={(date) => setInitialDate(date)}
              cancelLabel="Cancelar"
              okLabel="Salvar"
              hasWarning={false}
            />
            <DatePickers
              xs={3}
              name="finalDate"
              label="Fim"
              value={finalDate}
              onChange={(date) => setFinalDate(date)}
              cancelLabel="Cancelar"
              okLabel="Salvar"
              hasWarning={false}
            />
          </GridContainer>
        </form>

        <DataTableReact
          noHeader
          fixedHeader
          progressPending={loading}
          progressComponent={<DataTableLoading />}
          columns={columns}
          data={productions}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          sortServer
          onSort={handleSort}
          paginationDefaultPage={filter.page}
        />
      </ContentPanel>
    </>
  )
}